/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedMuseum
 */
export interface PatchedMuseum {
    /**
     * 
     * @type {number}
     * @memberof PatchedMuseum
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    readonly getAbsoluteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMuseum
     */
    image?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    fullyWheelchairAccessible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    partiallyWheelchairAccessible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    parking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    publicTransportationAccessible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    restaurant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    cafeteria?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    shop?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    childrenAndFamilyFriendly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMuseum
     */
    isMuseumAssociationMember?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedMuseum
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedMuseum
     */
    longitude?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedMuseum
     */
    categories?: Array<number>;
}

export function PatchedMuseumFromJSON(json: any): PatchedMuseum {
    return PatchedMuseumFromJSONTyped(json, false);
}

export function PatchedMuseumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedMuseum {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'getAbsoluteUrl': !exists(json, 'get_absolute_url') ? undefined : json['get_absolute_url'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'zipCode': !exists(json, 'zip_code') ? undefined : json['zip_code'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'shortDescription': !exists(json, 'short_description') ? undefined : json['short_description'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'fullyWheelchairAccessible': !exists(json, 'fully_wheelchair_accessible') ? undefined : json['fully_wheelchair_accessible'],
        'partiallyWheelchairAccessible': !exists(json, 'partially_wheelchair_accessible') ? undefined : json['partially_wheelchair_accessible'],
        'parking': !exists(json, 'parking') ? undefined : json['parking'],
        'publicTransportationAccessible': !exists(json, 'public_transportation_accessible') ? undefined : json['public_transportation_accessible'],
        'restaurant': !exists(json, 'restaurant') ? undefined : json['restaurant'],
        'cafeteria': !exists(json, 'cafeteria') ? undefined : json['cafeteria'],
        'shop': !exists(json, 'shop') ? undefined : json['shop'],
        'childrenAndFamilyFriendly': !exists(json, 'children_and_family_friendly') ? undefined : json['children_and_family_friendly'],
        'isMuseumAssociationMember': !exists(json, 'is_museum_association_member') ? undefined : json['is_museum_association_member'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
    };
}

export function PatchedMuseumToJSON(value?: PatchedMuseum | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'slug': value.slug,
        'email': value.email,
        'address': value.address,
        'zip_code': value.zipCode,
        'city': value.city,
        'state': value.state,
        'short_description': value.shortDescription,
        'description': value.description,
        'url': value.url,
        'image': value.image,
        'fully_wheelchair_accessible': value.fullyWheelchairAccessible,
        'partially_wheelchair_accessible': value.partiallyWheelchairAccessible,
        'parking': value.parking,
        'public_transportation_accessible': value.publicTransportationAccessible,
        'restaurant': value.restaurant,
        'cafeteria': value.cafeteria,
        'shop': value.shop,
        'children_and_family_friendly': value.childrenAndFamilyFriendly,
        'is_museum_association_member': value.isMuseumAssociationMember,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'categories': value.categories,
    };
}

